<template>
  <div class="moreType">
    <div class="moreTypeCon">
      <p class="mtTit  wow fadeInUp">探索菱势车型</p>
      <div class="mtTab  wow fadeInUp">
        <div class="mtTab_li" :class="actIndex == index?'active':''" v-for="(item,index) in tabList"
          :key="'mtTab'+index" @click="tabClick(index)">
          <span class="mtTab_li_sp">{{item.name}}</span>
          <i class="crile"></i>
        </div>
      </div>

      <div class="mtBox  wow fadeInUp">
	  
	        <div class="mtBox_item" v-show="actIndex == 0">
          <div class="swiper-container mtSwiper mtSwiper2">
            <div class="swiper-wrapper">
              <div class="swiper-slide">
                <div class="moacon">
				<div class="moacon_d">
                  <div class="moetinner" @click="toproduct06()">
           <img src="~@/assets/image/car/carhh.png" class="mo_sw" />
                     <div class="molt0906">
                        <img src="~@/assets/image/car/lefthh.png" class="lutai lt11" />
                      </div>
                      <div class="molt09106">
                        <img src="~@/assets/image/car/righthh.png" class="lutai lt12" />
                      </div>
                    </div>
                  </div>
                  <p class="moacon_p">黄金仓(货运版)</p>
                </div>
                 <div class="moacon_b">
        <span class="moBtn" @click="toproduct06()">了解更多</span>
        <span class="zxBtn" @click="toConsultation()">购车咨询</span>
      </div>
              </div>
			  
			  
			  
			        <div class="swiper-slide">
                <div class="moacon">
				<div class="moacon_d">
                  <div class="moetinner" @click="toproduct06()">
                    <img src="~@/assets/image/car/cary.png" class="mo_sw" />
                     <div class="molt090">
                        <img src="~@/assets/image/car/lefty.png" class="lutai lt11" />
                      </div>
                      <div class="molt0910">
                        <img src="~@/assets/image/car/righty.png" class="lutai lt12" />
                      </div>
                    </div>
                  </div>
                  <p class="moacon_p">黄金仓(客车版)</p>
                </div>
                 <div class="moacon_b">
        <span class="moBtn" @click="toproduct06()">了解更多</span>
        <span class="zxBtn" @click="toConsultation()">购车咨询</span>
      </div>
              </div>
			  
			  
			  
            </div>
             <div class="swiper-button-next"></div>
            <div class="swiper-button-prev"></div> 
          </div>
        </div>

        <div class="mtBox_item" v-show="actIndex == 1">
          <div class="swiper-container mtSwiper mtSwiper0">
            <div class="swiper-wrapper">
			
			
			
			  <div class="swiper-slide">
                <div class="moacon">
                  <div class="moacon_d">
                    <div class="moetinner" @click="toproduct011()">
                      <img src="~@/assets/image/car/jdk.png" class="mo_sw" />
                      <div class="molt0011">
                        <img src="~@/assets/image/car/jdk01.png" class="lutai lt11" />
                      </div>
                      <div class="molt0111">
                        <img src="~@/assets/image/car/jdk02.png" class="lutai lt12" />
                      </div>
                    </div>
                  </div>
                  <p class="moacon_p">菱势黄金大卡</p>
                </div>
                 <div class="moacon_b">
        <span class="moBtn" @click="toproduct011()">了解更多</span>
        <span class="zxBtn" @click="toConsultation()">购车咨询</span>
      </div>
              </div>
			  
			  
			
				  <div class="swiper-slide">
                <div class="moacon">
                  <div class="moacon_d">
                    <div class="moetinner" @click="toproduct09()">
                      <img src="~@/assets/image/car/car009.png" class="mo_sw" />
                      <div class="molt09">
                        <img src="~@/assets/image/car/leftc9.png" class="lutai lt11" />
                      </div>
                      <div class="molt091">
                        <img src="~@/assets/image/car/rightc9.png" class="lutai lt12" />
                      </div>
                    </div>
                  </div>
                  <p class="moacon_p">菱势黄金小卡</p>
                </div>
                 <div class="moacon_b">
        <span class="moBtn" @click="toproduct09()">了解更多</span>
        <span class="zxBtn" @click="toConsultation()">购车咨询</span>
      </div>
              </div>
			  
			  
              <div class="swiper-slide">
                <div class="moacon">
                  <div class="moacon_d">
                    <div class="moetinner" @click="toDemo()">
                      <img src="~@/assets/image/car/0.png" class="mo_sw" />
                      <div class="molt01">
                        <img src="~@/assets/image/car/01.png" class="lutai lt01" />
                      </div>
                      <div class="molt02">
                        <img src="~@/assets/image/car/02.png" class="lutai lt02" />
                      </div>
                    </div>
                  </div>
                  <p class="moacon_p">菱势黄金卡</p>
                </div>
                 <div class="moacon_b">
        <span class="moBtn" @click="toDemo()">了解更多</span>
        <span class="zxBtn" @click="toConsultation()">购车咨询</span>
      </div>
              </div>
			  
			  <div class="swiper-slide">
                <div class="moacon">
                  <div class="moacon_d">
                    <div class="moetinner" @click="toproductsh()">
                      <img src="~@/assets/image/car/sh30.png" class="mo_sw" />
                      <div class="molt0sh">
                        <img src="~@/assets/image/car/sh30q.png" class="lutai lt007" />
                      </div>
                      <div class="molt0sh1">
                        <img src="~@/assets/image/car/sh30s.png" class="lutai lt0071" />
                      </div>
                    </div>
                  </div>
                  <p class="moacon_p">菱势黄金卡双排</p>
                </div>
                 <div class="moacon_b">
        <span class="moBtn" @click="toproductsh()">了解更多</span>
        <span class="zxBtn" @click="toConsultation()">购车咨询</span>
      </div>
              </div>
			  
			  
			     <div class="swiper-slide">
                <div class="moacon">
                  <div class="moacon_d">
                    <div class="moetinner" @click="toproduct9()">
                      <img src="~@/assets/image/car/9.png" class="mo_sw" />
                      <div class="molt0900">
                        <img src="~@/assets/image/car/09.png" class="lutai lt09" />
                      </div>
                      <div class="molt09100">
                        <img src="~@/assets/image/car/091.png" class="lutai lt091" />
                      </div>
                    </div>
                  </div>
                  <p class="moacon_p">菱势黄金卡仓栅车	</p>
                </div>
                 <div class="moacon_b">
        <span class="moBtn" @click="toproduct9()">了解更多</span>
        <span class="zxBtn" @click="toConsultation()">购车咨询</span>
      </div>
              </div>
			  
	   <div class="swiper-slide">
                <div class="moacon">
                  <div class="moacon_d">
                    <div class="moetinner" @click="toproduct10()">
                      <img src="~@/assets/image/car/10.png" class="mo_sw" />
                      <div class="molt010">
                        <img src="~@/assets/image/car/010.png" class="lutai lt010" />
                      </div>
                      <div class="molt011">
                        <img src="~@/assets/image/car/011.png" class="lutai lt011" />
                      </div>
                    </div>
                  </div>
                  <p class="moacon_p">菱势黄金卡单/双层货柜	</p>
                </div>
                 <div class="moacon_b">
        <span class="moBtn" @click="toproduct10()">了解更多</span>
        <span class="zxBtn" @click="toConsultation()">购车咨询</span>
      </div>
              </div>

            </div>
            <div class="swiper-button-next"></div>
            <div class="swiper-button-prev"></div> 
          </div>
        </div>
		
        <div class="mtBox_item" v-show="actIndex == 2">
          <div class="swiper-container mtSwiper mtSwiper1">
            <div class="swiper-wrapper">
			
		
			
              <div class="swiper-slide">
                <div class="moacon">
                  <div class="moacon_d">
                    <div class="moetinner" @click="toproduct012()">
                      <img src="~@/assets/image/car/jxkp.png" class="mo_sw" />
                      <div class="molt012">
                        <img src="~@/assets/image/car/jxkp01.png" class="lutai lt11" />
                      </div>
                      <div class="molt0121">
                        <img src="~@/assets/image/car/jxkp02.png" class="lutai lt12" />
                      </div>
                    </div>
                  </div>
                  <p class="moacon_p">菱势黄金小卡PLUS</p>
                </div>
                 <div class="moacon_b">
        <span class="moBtn" @click="toproduct012()">了解更多</span>
        <span class="zxBtn" @click="toConsultation()">购车咨询</span>
      </div>
              </div>
			
              <div class="swiper-slide">
                <div class="moacon">
                  <div class="moacon_d">
                    <div class="moetinner" @click="toproduct4()">
                      <img src="~@/assets/image/car/2.png" class="mo_sw" />
                      <div class="molt21">
                        <img src="~@/assets/image/car/21.png" class="lutai lt11" />
                      </div>
                      <div class="molt22">
                        <img src="~@/assets/image/car/22.png" class="lutai lt12" />
                      </div>
                    </div>
                  </div>
                  <p class="moacon_p">菱势电卡</p>
                </div>
                 <div class="moacon_b">
        <span class="moBtn" @click="toproduct4()">了解更多</span>
        <span class="zxBtn" @click="toConsultation()">购车咨询</span>
      </div>
              </div>

              <div class="swiper-slide">
                <div class="moacon">
                  <div class="moacon_d">
                    <div class="moetinner" @click="toproduct2()">
                      <img src="~@/assets/image/car/3.png" class="mo_sw" />
                      <div class="molt31">
                        <img src="~@/assets/image/car/31.png" class="lutai lt11" />
                      </div>
                      <div class="molt32">
                        <img src="~@/assets/image/car/32.png" class="lutai lt12" />
                      </div>
                    </div>
                  </div>
                  <p class="moacon_p">菱势仓栅车</p>
                </div>
                 <div class="moacon_b">
        <span class="moBtn" @click="toproduct2()">了解更多</span>
        <span class="zxBtn" @click="toConsultation()">购车咨询</span>
      </div>
              </div>



              <div class="swiper-slide">
                <div class="moacon">
                  <div class="moacon_d">
                    <div class="moetinner" @click="toproduct3()">
                      <img src="~@/assets/image/car/4.png" class="mo_sw" />
                      <div class="molt41">
                        <img src="~@/assets/image/car/41.png" class="lutai lt41" />
                      </div>
                      <div class="molt42">
                        <img src="~@/assets/image/car/42.png" class="lutai lt42" />
                      </div>
                    </div>
                  </div>
                  <p class="moacon_p">菱势单/双层货柜</p>
                </div>
                 <div class="moacon_b">
        <span class="moBtn" @click="toproduct3()">了解更多</span>
        <span class="zxBtn" @click="toConsultation()">购车咨询</span>
      </div>
              </div>



            </div>
            <div class="swiper-button-next"></div>
            <div class="swiper-button-prev"></div>
          </div>
        </div>
        <div class="mtBox_item" v-show="actIndex == 3">
          <div class="swiper-container mtSwiper mtSwiper2">
            <div class="swiper-wrapper">
             <!-- <div class="swiper-slide">
                <div class="moacon">
				 <div class="moacon_d">
                  <div class="moetinner" @click="toproduct1()">
                    <img src="~@/assets/image/sw3.png" class="mo_sw" />
                  </div></div>
                  <p class="moacon_p"></p>
                </div> 
                 <div class="moacon_b">
        <span class="moBtn" @click="toproduct1()">了解更多</span>
        <span class="zxBtn" @click="toConsultation()">购车咨询</span>
      </div>
              </div>-->
			  
			  
			   <div class="swiper-slide">
                <div class="moacon">
                  <div class="moacon_d">
                    <div class="moetinner" @click="toproduct1()">
                      <img src="~@/assets/image/sw3.png" class="mo_sw" />
                      <div class="molt05">
                        <img src="~@/assets/image/car/008.png" class="lutai lt09" />
                      </div>
                      <div class="molt051">
                        <img src="~@/assets/image/car/081.png" class="lutai lt091" />
                      </div>
                    </div>
                  </div>
                  <p class="moacon_p">EV50货运版</p>
                </div>
                 <div class="moacon_b">
        <span class="moBtn" @click="toproduct1()">了解更多</span>
        <span class="zxBtn" @click="toConsultation()">购车咨询</span>
      </div>
              </div>
			  
			  
			   <div class="swiper-slide">
                <div class="moacon">
                  <div class="moacon_d">
                    <div class="moetinner" @click="toproduct08()">
                      <img src="~@/assets/image/car/08.png" class="mo_sw" />
                      <div class="molt08">
                        <img src="~@/assets/image/car/008.png" class="lutai lt09" />
                      </div>
                      <div class="molt081">
                        <img src="~@/assets/image/car/081.png" class="lutai lt091" />
                      </div>
                    </div>
                  </div>
                  <p class="moacon_p">EV50客运版</p>
                </div>
                 <div class="moacon_b">
        <span class="moBtn" @click="toproduct08()">了解更多</span>
        <span class="zxBtn" @click="toConsultation()">购车咨询</span>
      </div>
              </div>
			  
			  
			  
            </div>
            <div class="swiper-button-next"></div>
            <div class="swiper-button-prev"></div>
          </div>
        </div>
        <div class="mtBox_item" v-show="actIndex == 4">
          <div class="swiper-container mtSwiper mtSwiper3">
            <div class="swiper-wrapper">

              <div class="swiper-slide">
             <div class="moacon">
                  <div class="moacon_d">
                    <div class="moetinner" @click="toproduct5()">
                      <img src="~@/assets/image/car/5.png" class="mo_sw" />
                      <div class="molt51">
                        <img src="~@/assets/image/car/51.png" class="lutai lt41" />
                      </div>
                      <div class="molt52">
                        <img src="~@/assets/image/car/52.png" class="lutai lt42" />
                      </div>
                    </div>
                  </div>
                  <p class="moacon_p">菱势雪宝</p>
                </div>
                 <div class="moacon_b">
        <span class="moBtn" @click="toproduct5()">了解更多</span>
        <span class="zxBtn" @click="toConsultation()">购车咨询</span>
      </div>
              </div>

              <div class="swiper-slide">
              <div class="moacon">
                  <div class="moacon_d">
                    <div class="moetinner" @click="toproduct6()">
                      <img src="~@/assets/image/car/6.png" class="mo_sw" />
                      <div class="molt61">
                        <img src="~@/assets/image/car/61.png" class="lutai lt61" />
                      </div>
                      <div class="molt62">
                        <img src="~@/assets/image/car/62.png" class="lutai lt62" />
                      </div>
                    </div>
                  </div>
                  <p class="moacon_p">菱势冰宝</p>
                </div>
                 <div class="moacon_b">
        <span class="moBtn" @click="toproduct6()">了解更多</span>
        <span class="zxBtn" @click="toConsultation()">购车咨询</span>
      </div>
              </div>


            </div>
            <div class="swiper-button-next"></div>
            <div class="swiper-button-prev"></div>
          </div>
        </div>
       

      </div>
     
    </div>
  </div>
</template>
<script>
  import $ from 'jquery'
  import { WOW } from 'wowjs'
  import Swiper from 'swiper'
  import 'swiper/dist/css/swiper.min.css'
  import 'swiper/dist/js/swiper.min.js'
  export default {
    data () {
      return {
        actIndex: 0,
        mySwiper0: null,
        mySwiper1: null,
        mySwiper2: null,
        mySwiper3: null,
        mySwiper4: null,
        bannerList: [],
        tabList: [
		 {
            name: '大中面',
          },
          {
            name: '小卡',
          },
          {
            name: '微卡',
          },
          {
            name: '微面',
          },
          {
            name: '冷藏车',
          },
        
        ]

      }
    },
    created () {
    },

    mounted () {
      // 在项目加载完成之后初始化wow
      this.$nextTick(() => {
        let wow = new WOW({
          live: false,
        })
        wow.init()
      })
      let that = this
      this.mySwiper0 = new Swiper('.mtSwiper0', {
        observer: true,
        observeParents: true,
        speed: 1500,

        slidesPerView: 'auto',
        centeredSlides: true,
        // loop: true,
        navigation: {
          nextEl: '.mtSwiper0 .swiper-button-next',
          prevEl: '.mtSwiper0 .swiper-button-prev',
        },
        on: {
          slideChange: function () {
            console.log('mmmmmmm', this.activeIndex, this.previousIndex, $(this.el))
            if (this.activeIndex !== this.previousIndex) {
              if (this.activeIndex > this.previousIndex) {
                $('.mtSwiper0').addClass('car-active').removeClass('reverse')
              } else {
                $('.mtSwiper0').addClass('reverse').removeClass('car-active')
              }
            }
          },
          transitionEnd: function (event) {
            if (this.activeIndex !== this.previousIndex) {
              $(this.el).removeClass('car-active reverse')
            }
          },
        }
      })
      this.mySwiper1 = new Swiper('.mtSwiper1', {
        observer: true,
        observeParents: true,
        speed: 1500,

        slidesPerView: 'auto',
        centeredSlides: true,
        // loop: true,
        navigation: {
          nextEl: '.mtSwiper1 .swiper-button-next',
          prevEl: '.mtSwiper1 .swiper-button-prev',
        },
        on: {
          slideChange: function () {
            console.log('mmmmmmm', this.activeIndex, this.previousIndex, $(this.el))
            if (this.activeIndex !== this.previousIndex) {
              if (this.activeIndex > this.previousIndex) {
                $('.mtSwiper1').addClass('car-active').removeClass('reverse')
              } else {
                $('.mtSwiper1').addClass('reverse').removeClass('car-active')
              }
            }
          },
          transitionEnd: function (event) {
            if (this.activeIndex !== this.previousIndex) {
              $(this.el).removeClass('car-active reverse')
            }
          },
        }
      })
       this.mySwiper2 = new Swiper('.mtSwiper2', {
        observer: true,
        observeParents: true,
        speed: 1500,

        slidesPerView: 'auto',
        centeredSlides: true,
        // loop: true,
        navigation: {
          nextEl: '.mtSwiper2 .swiper-button-next',
          prevEl: '.mtSwiper2 .swiper-button-prev',
        },
        on: {
          slideChange: function () {
            console.log('mmmmmmm', this.activeIndex, this.previousIndex, $(this.el))
            if (this.activeIndex !== this.previousIndex) {
              if (this.activeIndex > this.previousIndex) {
                $('.mtSwiper2').addClass('car-active').removeClass('reverse')
              } else {
                $('.mtSwiper2').addClass('reverse').removeClass('car-active')
              }
            }
          },
          transitionEnd: function (event) {
            if (this.activeIndex !== this.previousIndex) {
              $(this.el).removeClass('car-active reverse')
            }
          },
        }
      })
       this.mySwiper3 = new Swiper('.mtSwiper3', {
        observer: true,
        observeParents: true,
        speed: 1500,

        slidesPerView: 'auto',
        centeredSlides: true,
        // loop: true,
        navigation: {
          nextEl: '.mtSwiper3 .swiper-button-next',
          prevEl: '.mtSwiper3 .swiper-button-prev',
        },
        on: {
          slideChange: function () {
            console.log('mmmmmmm', this.activeIndex, this.previousIndex, $(this.el))
            if (this.activeIndex !== this.previousIndex) {
              if (this.activeIndex > this.previousIndex) {
                $('.mtSwiper3').addClass('car-active').removeClass('reverse')
              } else {
                $('.mtSwiper3').addClass('reverse').removeClass('car-active')
              }
            }
          },
          transitionEnd: function (event) {
            if (this.activeIndex !== this.previousIndex) {
              $(this.el).removeClass('car-active reverse')
            }
          },
        }
      })
       this.mySwiper4 = new Swiper('.mtSwiper4', {
        observer: true,
        observeParents: true,
        speed: 1500,

        slidesPerView: 'auto',
        centeredSlides: true,
        // loop: true,
        navigation: {
          nextEl: '.mtSwiper4 .swiper-button-next',
          prevEl: '.mtSwiper4 .swiper-button-prev',
        },
        on: {
          slideChange: function () {
            console.log('mmmmmmm', this.activeIndex, this.previousIndex, $(this.el))
            if (this.activeIndex !== this.previousIndex) {
              if (this.activeIndex > this.previousIndex) {
                $('.mtSwiper4').addClass('car-active').removeClass('reverse')
              } else {
                $('.mtSwiper4').addClass('reverse').removeClass('car-active')
              }
            }
          },
          transitionEnd: function (event) {
            if (this.activeIndex !== this.previousIndex) {
              $(this.el).removeClass('car-active reverse')
            }
          },
        }
      })

    },
    methods: {
      tabClick (index) {
        this.actIndex = index
        // this.mySwiper.slideTo(index, 1000, false)
      },
      toConsultation () {
        this.$router.push({
          name: 'consultation',
          query: {
            // type: type,
          },
        })
      },
      toDemo () {
        this.$router.push({
          name: 'product5',
          query: {
            // type: type,
          },
        })
      },
      toproduct1 () {
        this.$router.push({
          name: 'product1',
          query: {
            id:5
          },
        })
      },
      toproduct2 () {
        this.$router.push({
          name: 'product1',
          query: {
            id:3
          },
        })
      },
	  	   toproduct08 () {
         this.$router.push({
          name: 'product8',
          query: {
            // type: type,
          },
        })
      },
      toproduct3 () {
        this.$router.push({
          name: 'product1',
          query: {
            id:2
          },
        })
      },
	      toproduct5 () {
        this.$router.push({
          name: 'product1',
          query: {
            id:6
          },
        })
      },
	  
	   toproduct011 () {
        this.$router.push({
          name: 'product11',
          query: {
            id:16
          },
        })
      },
	  
	  
	   toproduct012 () {
        this.$router.push({
          name: 'product12',
          query: {
            id:17
          },
        })
      },
	  
	  
	   toproduct06 () {
         this.$router.push({
          name: 'product6',
          query: {
            // type: type,
          },
        })
      },
	   toproduct9 () {
        this.$router.push({
          name: 'product1',
          query: {
            id:9
          },
        })
      },
  toproduct07 () {
         this.$router.push({
          name: 'product7',
          query: {
            // type: type,
          },
        })
      },
  toproduct09 () {
         this.$router.push({
          name: 'product9',
          query: {
            // type: type,
          },
        })
      },
	   toproduct10 () {
        this.$router.push({
          name: 'product1',
          query: {
            id:10
          },
        })
      },
	      toproduct6 () {
        this.$router.push({
          name: 'product1',
          query: {
            id:7
          },
        })
      },
	  
	   toproduct016 () {
        this.$router.push({
          name: 'product1',
          query: {
            id:15
          },
        })
      },
	       toproductsh() {
        this.$router.push({
          name: 'product7',
          query: {
            id:12
          },
        })
      },
      toproduct4 () {
        this.$router.push({
          name: 'product1',
          query: {
            id:4
          },
        })
      },

    },
  }
</script>


// WEBPACK FOOTER //
// src/components/home/moreType.vue